import { Observable } from 'rxjs';

import { OrganizationItem } from './organization-item.model';

export abstract class OrganizationApi {
	public abstract getOrganizations(): Observable<OrganizationItem[]>;
	public abstract getCurrentOrgId$(): Observable<string>;
	public abstract switchOrganization(orgId: string): Promise<void>;
}
